// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","faqSection__header":"faqSection_faqSection__header__6Nnba"};